import React, { useEffect,useState } from "react";
import Api from '../../api/global.service';
import DataTable from 'react-data-table-component';
import Swal from "sweetalert2";
import Modal from 'react-bootstrap/Modal';
import NoticiasEnviarForm from './NoticiasEnviarForm';
import DeleteButton from '../../nuup/componentes/Generales/DeleteButton';
import  '../../nuup/styles/Tablas.css'
import HerramientasTablas from '../../nuup/componentes/Tablas/HerramientasTablas/HerramientasTablas';
import NoticiasExportar from './NoticiasExportar';
var dataArray = [];
const NoticiasEnviarTabla = (props) => {
	const [show, setShow] = useState(false);
	const [datosFiltrados, setDatosFiltrados] = useState([]);

	const [filtro] = useState({
		usuario : 0,
		categoria : 0,
		ruta : 0
	});
	const [state, setState] = useState({
	id_user : 0,
	archivos: [],
	currentUsuario: null,
	currentIndex: -1
	});

	const columns = [
		{
			name: 'ID',
			selector: 'id_aviso',
			maxWidth: '150px',
			sortable: true,
			right: false
		},

		{
			name: 'TÍTULO',
			selector: 'titulo',
			maxWidth: '350px',
			sortable: true,
			right: false
		},
		{
			name: 'NOTICIA',
			selector: 'aviso',
			maxWidth: '550px',
			sortable: true,
			right: false
		},

		{
			name: 'FECHA ENVÍO',
			selector: 'created_at',
			maxWidth: '200px',
			sortable: true,
			right: false
		},
		{
			name: 'OPCIONES',
			button: true,
			maxWidth: '150px',
			cell: (row) => <><DeleteButton onClick={() => deleteNoticia(row.uuid)}><i className="fa fa-trash"></i></DeleteButton></>,
		},

	];

	useEffect(() => {
		obtenerNoticias();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [filtro]);

	  const obtenerNoticias = ()  => {
		Swal.showLoading();	
		Api.getAll('avisos/noticias',filtro)
		  .then(response => {
			Swal.close();
			dataArray = response.data.data; 
			setDatosFiltrados(dataArray);
		  })
		  .catch(e => {
			Swal.close();
			console.log(e);
		  });
	  }

	  // eslint-disable-next-line no-unused-vars
	  const [selectedRows, setSelectedRows] = React.useState([]);
	     // eslint-disable-next-line no-unused-vars 
	  const [toggleCleared, setToggleCleared] = React.useState(false);
  

	  const handleRowSelected = React.useCallback(state => {
		setSelectedRows(state.selectedRows);
		props.onChangeSeleccionados(state.selectedRows);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const deleteNoticia = (uuid) => {		
		Swal.fire({
			title: '¿Esta seguro?',
			text: "El registro se eliminará",
			icon: 'warning',
			showCancelButton: true,
			confirmButtonColor: '#3085d6',
			cancelButtonColor: '#d33',
			confirmButtonText: 'Si, eliminar!'
		  }).then((result) => {
			if (result.isConfirmed) {
				Api.delete('avisos/noticias',uuid)
				.then(response => {
					let _result = response.data;
					if(_result.success === 1){
						Swal.close();
						Swal.fire(
						  'Eliminado!',
						  'Usuario eliminado.',
						  'success'
						);
					}
				obtenerNoticias();
				})
				.catch(e => {
				  Swal.fire(
					'Error!',
					'Error al eliminar el usuario.',
					'error'
				  );
				  obtenerNoticias();
				});

			}
		  })

	};


	
	const hideFormEdit = () => {
		setState({...state,id_user : 0});
		setShow(false);
	};

	const handleChange = (datosFiltrados) => {setDatosFiltrados(datosFiltrados);}


	return (
      <div>
		  {/*
			<div className="row">
			  <div className="col-md-8 offset-md-2">
				<div className="row">
					<div className="col-md-3">
						<FiltroUsuarios onChange={(event) => filtrarTabla('usuario',event.target.value)} showLoading={false}  />
					</div>
					<div className="col-md-6">
						<FiltroRutas onChange={(event) => filtrarTabla('ruta',event.target.value)} showLoading={false}  />
					</div>

					<div className="col-md-3">
						<FiltroNotificacionesCategorias onChange={(event) => filtrarTabla('categoria',event.target.value)} showLoading={false}  />
					</div>
				</div>
			  </div>
		  </div>
		  */}

		  <HerramientasTablas 
				txtBusqueda="Buscar noticia" 
				datosTabla={dataArray} 
				urlRegistrar="/administracion/noticias/registrar/0" 
				columnasFiltrar={["id_aviso","productor","categoria","titulo","aviso","creado"]}
				exportar={NoticiasExportar}
				onFiltrar={(datosFiltrados) => handleChange(datosFiltrados)}
			/>


			<DataTable
				pagination
				columns={columns}
				data={datosFiltrados}
				Clicked
				noDataComponent={'Sin datos por mostrar'}
				onSelectedRowsChange={handleRowSelected}
			/>

			<Modal
              show={show}
              onHide={() => hideFormEdit()}
              dialogClassName="modal-90w"
              aria-labelledby="example-custom-modal-styling-title"
              size="lg"
            >
              <Modal.Header closeButton>
                <Modal.Title id="example-custom-modal-styling-title">
                  Enviar notificación
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <NoticiasEnviarForm />
              </Modal.Body>
            </Modal>


		</div>
    );
  };
export default NoticiasEnviarTabla;
